/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import logo from '../img/logo.png';
import { useNavigate } from "react-router-dom";
import "../components/navbar.css";

// import { Button } from 'react-bootstrap';

// import './_dark-mode.scss';
// import {FaMoon, FaSun} from "react-icons/fa";

// NEED fix size of text less 1334px!!!!!

// const Header = ({currentUser, showModeratorBoard, showAdminBoard, logOut}) => {
const Header = ({logOut}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
      const mode = window.localStorage.getItem('mode');
      const root = document.getElementsByTagName('html')[0];
  
      if (mode !== undefined && mode === 'dark') {
        setIsDarkMode(true);
        root.classList.add('dark-mode');
      } else {
        setIsDarkMode(false);
        root.classList.remove('dark-mode');
      }
    }, []);

    const toggleTheme = () => {
      const root = document.getElementsByTagName('html')[0];
  
      if (isDarkMode) {
        window.localStorage.setItem('mode', 'light');
        setIsDarkMode(false);
        root.classList.remove('dark-mode');
      } else {
        window.localStorage.setItem('mode', 'dark');
        setIsDarkMode(true);
        root.classList.add('dark-mode');
      }
      setIsDarkMode(!isDarkMode);
    };

    // const handleSwitcherClick = () => {
    //   toggleTheme();
    // };
  
    const menuSwitch = (
      <label className="form-check-label" htmlFor="theme-mode">
      <i className="ai-moon text-info h3" onClick={() => setIsDarkMode(isDarkMode)}> </i>
      </label>
      
    );

    const lightSwitch = (
      <label className="form-check-label" htmlFor="theme-mode">
      <i className="ai-sun text-success h3" onClick={() => setIsDarkMode(!isDarkMode)} > </i>
      </label>
    );

    const navigate = useNavigate();
    const handleClick = () => {
        logOut();
        navigate("/");
      //   localStorage.clear();
    }

    return ( 
        <>
        {/* <div className="page-wrapper">  */}

         {['xxl'].map((expand) => (
        <Navbar key={expand} expand={expand} className="navL fixed-top mb-3 bg-primary">
          <Container fluid>
             <Navbar.Brand className="text-success me-auto" href="/">
              <p className="m-2"> <img src={logo} alt="logo" style={{ maxWidth: "50px"}} /></p>
              Форматы
            </Navbar.Brand>
           
            {/* <div className="form-check form-switch mode-switch order-lg-2 me-3 p-2 me-lg-4 ms-auto dark-mode"> */}
         
            <div className="ms-auto d-flex align-items-center">
              <label className="form-check form-switch mode-switch order-lg-2 pe-2 mb-0 dark-mode d-xxl-none" onClick={() => toggleTheme()}>
                {isDarkMode ? menuSwitch : lightSwitch}
              </label>
                
          {/* <input
            className="form-check-input"
            type="checkbox"
            id="theme-switcher"
            checked={isDarkMode}
            onChange={handleSwitcherClick}
          /> 
          
          <label className="form-check-label" htmlFor="theme-switcher">
            {isDarkMode ? <i className="ai-moon text-dark display-6"> </i> : <i className="ai-sun text-warning display-6"> </i>}
          </label> */}
         {/* <FaSun className={`text-warning display-6 ${isDarkMode ? 'sun-hidden' : ''}`} />
          <label className="form-check-label" htmlFor="theme-switcher">
            <input
              className="form-check-input"
              type="checkbox"
              id="theme-switcher"
              checked={isDarkMode}
              onChange={handleSwitcherClick}
            />
            <span className="slider"></span>
            <span className={`switcher-label ${isDarkMode ? 'moon-label' : 'sun-label'}`}>
              {isDarkMode ? 'Moon' : 'Sun'}
            </span>
          </label>
          <FaMoon className={`text-dark display-6 ${isDarkMode ? '' : 'moon-hidden'}`} /> */}
      
            {/* </div> */}
            {/* <div className="form-check form-switch mode-switch order-lg-2 me-3 me-lg-4 ms-auto" databstoggle="mode">
              <input
                className="form-check-input"
                type="checkbox"
                id="theme-mode"
                checked={isDarkMode}
                onChange={toggleTheme}
              />
      <label className="form-check-label" htmlFor="theme-mode">
        <i className={`ai-sun fs-lg text-light ${isDarkMode ? 'moon-offset' : ''}`}></i>
      </label>
      <label className="form-check-label" htmlFor="theme-mode">
        <i className={`ai-moon fs-lg text-dark ${isDarkMode ? 'sun-offset' : ''}`}></i>
      </label>
    </div> */}
              <Navbar.Toggle
               aria-controls={`offcanvasNavbar-expand-${expand}`} 
               className="navbar-toggler bg-success ms-2 me-1 rounded"
               />
            </div>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
             
              <Offcanvas.Header className="bg-danger" closeButton>
                <Offcanvas.Title className="text-success"  id={`offcanvasNavbarLabel-expand-${expand}`}>
                 Наши Форматы
                </Offcanvas.Title>
              </Offcanvas.Header>
              
              <Offcanvas.Body className="bg-primary text-light">
                <Nav className="justify-content-end flex-grow-2 pe-3 text-light ml-auto ms-xxl-3">
                  <NavDropdown
                    title="О нас" 
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/aboutus">Наша Команда
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/pay">Реквизиты компании
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/contact">Контакты
                     </NavDropdown.Item>
                  </NavDropdown>
                 
                  <NavDropdown
                    title="Детские ФОРМАТЫ"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/english">Английский язык
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/class">Рисование/лепка
                     </NavDropdown.Item>
                     <NavDropdown.Item href="/afterschool">Продленка
                      </NavDropdown.Item>
                     <NavDropdown.Item href="/logoped">Логопед
                     </NavDropdown.Item>
                     {/* <NavDropdown.Item href="/design"> Графический Дизайн
                     </NavDropdown.Item> */}
                     <NavDropdown.Item href="/music">Музыкальное направление
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/prof">Профориентация
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/vacation">Полезные каникулы
                     </NavDropdown.Item>
                     <NavDropdown.Item href="/chest">Шахматы
                     </NavDropdown.Item>
                     
                  </NavDropdown>

                  <NavDropdown
                    title="Взрослые ФОРМАТЫ"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/family">Семейный коучинг
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/personal">Личностный рост
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/coaching">Управленческий коучинг
                     </NavDropdown.Item>
                     <NavDropdown.Item href="/women">Женский клуб Women_art_trick
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/niceage">Клуб «Приятный возраст»
                     </NavDropdown.Item>
                    {/* <NavDropdown.Item href="/travel">Психологический туризм
                     </NavDropdown.Item> */}
                     <NavDropdown.Item href="/englishadult">Английский язык
                     </NavDropdown.Item>
                  </NavDropdown>

                  <NavDropdown
                    title="ФОРМАТЫ Бизнеса"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/executive">Executive коучинг
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/team">Командный Коуч
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/training">Бизнес Тренинги
                     </NavDropdown.Item>
                     <NavDropdown.Item href="/testing">Тестирование сотрудников <br/>и Увеличение продаж
                     </NavDropdown.Item>
                     <NavDropdown.Item href="/mentor">Наставничество
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/webdev">Разработка сайтов
                     </NavDropdown.Item>
                  </NavDropdown>

                  <NavDropdown
                    title="Публикации"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/promo">Система лояльности
                     </NavDropdown.Item>
                    <NavDropdown.Item href="/blog">Блог & Новости
                     </NavDropdown.Item>
                    {/* <NavDropdown.Item href="/photos">Фото & Видео
                     </NavDropdown.Item> */}
                  </NavDropdown>
                  <Nav.Link href="https://форматы-профтест.рф" className="nav-link text-success">Пройти Тесты</Nav.Link>
                  <Nav.Link href="https://demo.alfacrm.pro/company/1/dashboard/index" className="nav-link text-success d-xxl-none">Зайти в Кабинет</Nav.Link>
                  {/* <div className="navbar-nav mr-auto">
          
          {showModeratorBoard && (
            <Nav.Link href="/mod">Moderator Board</Nav.Link>
          )}

          {showAdminBoard && (
            <Nav.Link href="/admin">Admin Board</Nav.Link>
          )}

          {currentUser && (
            <Nav.Link href="/user">Личный кабинет</Nav.Link>
          )}
        </div> */}

        {/* {currentUser ? (
          <div className="navbar-nav ml-auto">
            <Nav.Link href="/profile">{currentUser.username}</Nav.Link>
            <Nav.Link href="/" onClick={handleClick}>Выйти</Nav.Link>
          </div>
        ) : (
          <div className="navbar-nav ml-auto">
            <Nav.Link href="/login" className="nav-link text-success">Зайти</Nav.Link>
            <Nav.Link href="/register" className="nav-link text-success">Создать Аккаунт </Nav.Link>
          </div>
        )} */}
            </Nav>
            <div className="d-none d-xxl-flex align-items-center header-right-cluster">
              <Nav.Link href="https://demo.alfacrm.pro/company/1/dashboard/index" className="nav-link text-success mb-0">Зайти в Кабинет</Nav.Link>
              <label className="form-check form-switch mode-switch mb-0 ms-2 dark-mode d-flex" onClick={() => toggleTheme()}>
                {isDarkMode ? menuSwitch : lightSwitch}
              </label>
            </div>
            <div className="text-center mt-3 d-xxl-none">
             <p className="mb-0 text-light text-muted sticky-bottom">2022-2025 &copy; Все права принадлежат Мультиформатному Центру Развития "Форматы".</p>
            </div>
            </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}

        </>
        // </div>
    )

}

export default Header;
